
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2, Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ServicesTable } from './ServicesTable';

interface Service {
  id: string;
  service_name: string;
  description: string | null;
  price: number;
  duration_minutes: number;
  formats_available: string[];
  is_active: boolean;
  currency: string;
  service_photo: string | null;
  is_free_session: boolean;
  created_at: string;
  updated_at: string;
}

interface ServicesContentProps {
  services: Service[];
  isLoading: boolean;
  onToggleActive: (serviceId: string, currentStatus: boolean) => void;
  onEdit: (service: Service) => void;
  onDelete: (serviceId: string) => void;
}

export const ServicesContent: React.FC<ServicesContentProps> = ({
  services,
  isLoading,
  onToggleActive,
  onEdit,
  onDelete
}) => {
  const { t } = useTranslation('dashboard');

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-12">
        <Loader2 className="h-8 w-8 animate-spin text-amber-600" />
      </div>
    );
  }

  if (services.length === 0) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center p-12">
          <Info className="h-12 w-12 text-gray-300 mb-4" />
          <h3 className="text-lg font-medium mb-2">{t('servicesManagement.noServicesTitle')}</h3>
          <p className="text-gray-500 text-center mb-4">
            {t('servicesManagement.noServicesDescription')}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <ServicesTable
      services={services}
      onToggleActive={onToggleActive}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
};
